const isArrayEqual = (array1 = [], array2 = []) => {
  if (array1.length !== array2.length) return false

  const map1 = {}

  array1.forEach(element1 => {
    map1[element1] = true
  })

  return array2.every(element2 => map1[element2])
}

export default isArrayEqual